import { Box, Typography, CircularProgress } from '@mui/material'
import React from 'react'

const loadingStyle = {
    text: {
        fontSize: '1.25rem',
        fontWeight: 'semibold',
        color: '#000',
        textAlign: 'center',
        marginBottom: '1rem',
    },
    spinner: {
        color: "#FC581F"
    }
}


const ShowLoading = ({text = 'Procesando Información...'}) => {
  return (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%',
        }}
    >
        <CircularProgress
            sx={loadingStyle.spinner}
            size={48} // adjust spinner size
            thickness={5} // optional: thickness of stroke
        />
        <Typography sx={loadingStyle.text}>{text}</Typography>
    </Box>
  )
}

export default ShowLoading